import React, { useState, useEffect, Fragment, useMemo } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import SideBar from "../Dashboard/SideBar";
import {
  useAddUpdateManageListMutation,
  useDeleteManageListMutation,
  useDeleteManageListQuery,
  useFetchHeadersByRowIdMutation,
  useFetchManageListDataQuery,
  useFetchValuesByRowIdMutation,
  useLazyFetchDynamicDataTableDataQuery,
} from "../../utils/customer/customerTaskTable";
import AddDynamicTableModal from "./AddDynamicTableModal";
import HeaderDashboard from "../HeaderDashboard";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import UserNameHover from "./UserNameHover";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { ReactComponent as EditIcon } from "../../assets/images/editIconCoaTable.svg";
import AddManageListDialog from "./AddManageListDialog";
import { getUserTokeData } from "../../utils/userSlice";
import ManageListDetails from "./ManageListDetails";
import { combine } from "rrule/dist/esm/dateutil";
import EditPencilIcon from "../../assets/images/icons/EditPencilIcon";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import { ReactComponent as NoManageList } from "../../assets/images/NoManageList.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/icons/DeleteAction.svg";

const ManageList = () => {
  const [tableNameData, setTableNameData] = useState("");
  const [tableBodyData, setTableBodyData] = useState([]);
  const [showBackArrow, setShowBackArrow] = useState(false);
  const [action, setAction] = useState(null);
  const { token } = useRequireAuth();
  const [SelecteduserId, setSelecteduserId] = useState(null);
  const [SelectedRow, setSelectedRow] = useState(null);
  const [editData, setEditData] = useState();

  const [openShowDetails, setOpenShowDetails] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [choiceToDelete, setChoiceToDelete] = useState(null);
  // from this i am working

  const [addEditManageList, setAddEditManageList] = useState("");
  const [listData, setListData] = useState({});
  const keysToExclude = ["id"];
  const dispatch = useDispatch();
  const [activeEditId, setActiveEditId] = useState(null);
  const [isAddActive, setIsAddActive] = useState(false);
  const [isEditActive, setIsEditActive] = useState(false);

  const {
    data: manageListAll,
    refetch: refetchManageListData,
    isLoading: isManageListLoading,
    isError: isManageListError,
  } = useFetchManageListDataQuery({ token: token });

  const handleNavigate = (userData) => {
    setAddEditManageList(true);
    setEditData(userData);
    setSelecteduserId(userData.userUuid);
  };

  const handleNavigateMore = (...data) => {
    setEditData(data);
    setOpenShowDetails(true);
  };

  const createColumnDefinitions = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      pushAlert({
        message: "No data available",
        type: "warning",
        visible: true,
      });
      return;
    }

    const firstObject = data[0];
    const keys = Object?.keys(firstObject)?.filter((key) => !keysToExclude.includes(key));

    return keys?.map((key) => ({
      accessor_key: key,
      label: key
        ?.split("_")
        ?.map((word) => word.charAt(0)?.toUpperCase() + word?.slice(1))
        ?.join(" "),
      ...(key === "list_name" && {
        callingFunction: (rowData) => {
          setListData(rowData);
        },
      }),
    }));
  };

  const TabletHeader = createColumnDefinitions(tableBodyData, handleNavigate, handleNavigateMore);
  const memoizedData = useMemo(() => manageListAll?.data || []);

  useEffect(() => {
    if (manageListAll) {
      const { data, ...restData } = manageListAll?.data;
      setTableBodyData(memoizedData);
      setTableNameData("Manage List");
    }
  }, [manageListAll, refetchManageListData]);

  useEffect(() => {
    if (!addEditManageList) {
      setIsHovered(false);
    }
  }, [addEditManageList]);

  const handleBackClick = () => {
    setListData({});
    setTableNameData("Manage List");
    setTableBodyData(memoizedData);
    setShowBackArrow(false);
  };

  const tableName = showBackArrow ? (
    <span className="flex items-center cursor-pointer" onClick={handleBackClick}>
      <span className="mr-2">←</span> {tableNameData}
    </span>
  ) : (
    tableNameData
  );

  const closePopup = () => {
    setEditData();
    setAddEditManageList(false);
    setActiveEditId(null);
    setIsAddActive(false);
  };

  const handleAddEditManageList = (rowData, data) => {
    if (rowData.type === "add") {
      setSelectedRow("");
      setIsAddActive(true);
      setIsEditActive(false);
    } else {
      setSelectedRow(data);
      setAction("edit");
      setActiveEditId(data?.id);
      setIsAddActive(false);
      setIsEditActive(true);
    }
    setAddEditManageList(true);
  };

  const [
    AddUpdateManageList,
    { data: AddEditResponseData, isError: isAddEditError, isSuccess: isAddEditSuccess, isLoading: isAddEditLoading },
  ] = useAddUpdateManageListMutation();

  const handelAddEditSave = (payload) => {
    AddUpdateManageList({ token, payload });
  };

  useEffect(() => {
    //loading
    if (isAddEditLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isAddEditSuccess) {
      dispatch(
        pushAlert({
          message: AddEditResponseData.message,
          type: "success",
          visible: true,
        })
      );
      if (AddEditResponseData?.status) {
        closePopup();
        refetchManageListData();
      }
    }
    // catch block
    if (isAddEditError) {
      dispatch(pushAlert({ message: AddEditResponseData?.message, type: "danger", visible: true }));
    }
  }, [isAddEditSuccess, isAddEditError, isAddEditLoading]);

  const [
    DeleteManageList,
    { data: deleteResponseData, isError: isDeleteError, isSuccess: isDeleteSuccess, isLoading: isDeleteLoading },
  ] = useDeleteManageListMutation();

  const handleDeleteManageList = (item) => {
    const payload = item?.id;
    setChoiceToDelete(item);
    DeleteManageList({ token, payload });
  };

  useEffect(() => {
    //loading
    if (isDeleteLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isDeleteSuccess) {
      dispatch(
        pushAlert({
          message: deleteResponseData.message,
          type: "success",
          visible: true,
        })
      );
      if (deleteResponseData?.status) {
        closePopup();
        refetchManageListData();
      }
    }
    // catch block
    if (isDeleteError) {
      dispatch(pushAlert({ message: deleteResponseData?.message, type: "danger", visible: true }));
    }
  }, [isDeleteSuccess, isDeleteError, isDeleteLoading]);

  const handleConfirmDelete = () => {
    if (choiceToDelete) {
      handleDeleteManageList(choiceToDelete);
    }
    setShowConfirmation(false);
    setChoiceToDelete(null);
  };

  const handleManageListRowDataDelete = (item) => {
    setShowConfirmation(true);
    setChoiceToDelete(item);
  };

  return (
    <div className="flex flex-col gap-1 justify-around h-[100vh]">
      <HeaderDashboard />
      <div class="flex gap-5 px-2 grow min-h-0 box-border">
        <div className="w-2/12">
          <SideBar />
        </div>
        {Boolean(!listData?.id) ? (
          <div className="flex flex-col grow min-w-0 ">
            <ReactTableComponent
              apiStates={{
                body: {
                  isLoading: isManageListLoading,
                  isError: isManageListError,
                },
              }}
              alternateDivs={{
                emptyData: (
                  <div className="w-full h-full">
                    <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                      <NoManageList className="h-[300px] w-[300px]" />
                      <span className="text-14 text-black text-sm font-400 font-poppins ">
                        No ManageList is Available.
                      </span>
                      {/* <span
                                onClick={() => openPopup()}
                                className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                              >
                                + Add Service
                              </span> */}
                    </div>
                  </div>
                ),
              }}
              tablename={tableName}
              headers={TabletHeader}
              body={tableName === "Manage List" ? manageListAll?.data : []}
              actionField={
                <div className="flex gap-1 ">
                  <button
                    onClick={() => handleAddEditManageList({ type: "add", source: "actionField" })}
                    type="button"
                    className="cursor-pointer  border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                  >
                    <PlusIcon
                      isHovered={isHovered}
                      // isActive={addEditManageList}
                      isActive={isAddActive}
                    />
                  </button>
                </div>
              }
              actionColumn={(item) => {
                return (
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      // onClick={() => handleDeleteManageList(item)}
                      onClick={() => handleManageListRowDataDelete(item)}
                    >
                      <DeleteIcon />
                    </button>

                    <button
                      onClick={() => handleAddEditManageList({ type: "edit", source: "actionField" }, item)}
                      className="cusror-pointer  text-454545 hover:text-[#1D4469]"
                      type="button"
                    >
                      <EditPencilIcon
                        closeButton={Boolean(activeEditId === item?.id)}
                        size={18}
                        className="text-[#969BA9] hover:text-[#1D4469] cursor-pointer"
                      />
                    </button>
                  </div>
                );
              }}
            />
          </div>
        ) : (
          <div className="flex flex-col grow min-h-0 ">
            <ManageListDetails listData={listData} handleBackClick={handleBackClick} />
          </div>
        )}
      </div>

      {addEditManageList && (
        <AddManageListDialog
          open={addEditManageList}
          closePopup={closePopup}
          handelsave={handelAddEditSave}
          editData={SelectedRow}
        />
      )}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={handleConfirmDelete}
          onClose={() => {
            setShowConfirmation(false);
            setChoiceToDelete(null);
          }}
          title="Delete"
          message={
            <>
              Are you sure you want to delete <span className="font-semibold">{choiceToDelete?.list_name}</span>{" "}
              permanently ?
            </>
          }
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
    </div>
  );
};
export default ManageList;
